import MiscQuoteService from './MiscQuoteService'
import MiscQuoteRoutes from './route-types'
import StoreUtil from '@/store/utils'
import DeepDiff from 'deep-diff'
import { md5 } from '@/components/crypto'

const tag = 'miscquote'

const state = {
  returnRoute: {},
  baseIndex: 0,
  currentIndex: 0,
  snapshots: [],
  isUpdateInvoice: false,
  storeCustomer: null,
  readOnlyView: false
}

const getters = {
  returnRoute: state => state.returnRoute,
  snapshots: state => state.snapshots,
  baseSnapshot: state => state.snapshots[state.baseIndex],
  currentSnapshot: state => state.snapshots[state.currentIndex],
  snapshotDiff: state => {
    if (state.snapshots[state.baseIndex] && state.snapshots[state.currentIndex]) {
      return DeepDiff.diff(state.snapshots[state.baseIndex], state.snapshots[state.currentIndex])
    } else {
      return null
    }
  },
  isUpdateInvoice: state => state.isUpdateInvoice,
  storeCustomer: state => state.storeCustomer,
  readOnlyView: state => state.readOnlyView
}

const actions = {
  async getStoreItem({ commit }, id) {
    let entity = StoreUtil.getStorage(id, tag)
    if (!entity || (entity && !entity.isNew)) {
      const hash = entity ? md5(JSON.stringify(entity)) : ''
      const data = await MiscQuoteService.getEntity(id, hash)
      if (data) {
        console.log('from WebApi')
        entity = data
      } else {
        console.log('from sessionStorage')
      }
    }
    StoreUtil.setStorage(entity.miscQuoteId, tag, entity)
    commit('saveInitialSnapshots', entity)
  },
  async editStoreItem({ commit }, id) {
    const entity = StoreUtil.getStorage(id, tag) || (await MiscQuoteService.getEntity(id, ''))
    StoreUtil.setStorage(entity.miscQuoteId, tag, entity)
    commit('saveInitialSnapshots', entity)
    StoreUtil.routeToDetail(MiscQuoteRoutes.MiscQuoteListView.path, entity.miscQuoteId, false)
  },
  async addStoreItem({ commit }) {
    const entity = await MiscQuoteService.getNewEntity()
    StoreUtil.setStorage(entity.miscQuoteId, tag, entity)
    commit('saveInitialSnapshots', entity)
    StoreUtil.routeToDetail(MiscQuoteRoutes.MiscQuoteListView.path, entity.miscQuoteId, true)
  },
  saveSnapshot({ commit }, entity) {
    commit('saveSnapshot', entity)
  },
  clearSnapshots({ commit }, id) {
    StoreUtil.removeStorage(id, tag)
    commit('clearSnapshots')
  },
  setReturnRoute({ commit }, route) {
    commit('setReturnRoute', route)
  },
  setIsUpdateInvoice({ commit }, isUpdateInvoice) {
    commit('setIsUpdateInvoice', isUpdateInvoice)
  },
  clearInvoiceState({ commit }) {
    commit('clearInvoiceState')
  },
  setStoreCustomer({ commit }, customer) {
    commit('setStoreCustomer', customer)
  },
  async getQuoteCustomer({ commit }, payload) {
    if (!state.storeCustomer || payload.refresh) {
      const entity = await MiscQuoteService.getCustomerEntity(payload.id)
      commit('setStoreCustomer', entity)
    }
  },
  setReadOnlyView({ commit }, value) {
    commit('setReadOnlyView', value)
  }
}

const mutations = {
  saveInitialSnapshots(state, entity) {
    state.snapshots = []
    state.snapshots.splice(0, 1, entity)
    state.snapshots.splice(1, 1, entity)
    state.currentIndex = state.snapshots.length - 1
  },
  saveSnapshot(state, entity) {
    state.snapshots.splice(state.currentIndex, 1, entity)
  },
  clearSnapshots(state) {
    state.snapshots = []
    state.baseIndex = 0
    state.currentIndex = 0
  },
  setReturnRoute(state, route) {
    state.returnRoute = route
  },
  setIsUpdateInvoice(state, isUpdateInvoice) {
    state.isUpdateInvoice = isUpdateInvoice
  },
  clearInvoiceState(state) {
    state.isUpdateInvoice = false
  },
  setStoreCustomer(state, customer) {
    state.storeCustomer = customer
  },
  setReadOnlyView(state, value) {
    state.readOnlyView = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
